import { api } from "./api";

const challan2Api = api.injectEndpoints({
  endpoints: (builder) => ({
    allChallan: builder.query({
      query: () => "/challan_master",
      providesTags: ["challan_master"],
    }),
    getBothChallan: builder.query({
      query: (chId) => `both_challan?chId=${chId}`,
      providesTags: ["challan_master"],
    }),
    getChallanByChNo: builder.query({
      query: (chno) => `challanByChNo/${chno}`,
      providesTags: ["challan_master"],
    }),
    addChallan: builder.mutation({
      query: (newData) => ({
        url: "/create_challan",
        method: "POST",
        body: newData,
      }),
      invalidatesTags: ["challan_master"],
    }),
    removeChallan2: builder.mutation({
      query: (id) => ({
        // url: `orders2/${id}`,
        url: `/challan2s?ch_no=${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["challan_master"],
    }),
    editChallan2: builder.mutation({
      query: ({ id, ...editData }) => ({
        url: `/challan2/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["challan_master"],
    }),
  }),
});

export const {
  useAllChallanQuery,
  useGetBothChallanQuery,
  useGetChallanByChNoQuery,
  useAddChallanMutation,
  useRemoveChallan2Mutation,
  useEditChallan2Mutation,
} = challan2Api;
